import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import STC from "../../../STCLibrary/STCFactory/STCFactory";
import { EmergencyAPIs } from "../../../API/EmergencyAPIs/EmergencyAPIs";
import ApiResponseHandler from "../../../STCLibrary/ApiResponseHandler/ApiResponseHandler";
import NotificationContext from "../../../STCLibrary/NotificationSystem/NotificationContext";
import ColouredLoadingSymbol from "../../../STCLibrary/LoadingAnimation/ColouredLoadingSymbol/ColouredLoadingSymbol";
import Logo from '../../../Resources/Logo/LogoBordered.png';
import EmergencyPaymentForm from "./EmergencyPaymentForm/EmergencyPaymentForm";
import { LogoutAPIs } from "../../../API/LogoutAPIs/LogoutAPIs";

export default function EmergencyPayment(){

    const routeParams = useParams();
    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const [responseData, setResponseData] = useState('');
    const [loading, setLoading] = useState(true);
    const [used, setUsed] = useState(true);
    const [errorMsg, setErrorMsg] = useState('');

    

    const handleVerifyLink = (code) => {

        document.cookie = "cookie1=; expires=; path=/";

        LogoutAPIs.PostLogout()
        .then((response) => {

            EmergencyAPIs.GetEmergencyLinkVerified(code)
                .then((response) => {
                    console.log(response);
                    if(response.status === 200){
                        setUsed(response.data.used);
                        if(response.data.used === true){
                            setErrorMsg('This payment link has already been used.')
                        }
                        setLoading(false);
                    }
                    setResponseData(response.data);
                    // setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    setErrorMsg('Error Code: ' + err.response.status + '. Please try again later.')
                    setUsed(true);
                    setLoading(false);
                    // ApiResponseHandler(err.response, notificationCtx, navigate);
                })
        })
        .catch((err) => {
            console.log(err);
            setErrorMsg('Error Code: ' + err.response.status + '. Please try again later.')
            setUsed(true);
            setLoading(false);
            // ApiResponseHandler(err.response, notificationCtx, navigate);
        })
        
        
    }

    

    useEffect(() => {
        handleVerifyLink(routeParams.emergencyPaymentCode);
    }, [routeParams.emergencyPaymentCode])


    return(
        <div className="login-container">
            <div className="coloured-box-container">
                <div className='coloured-box'></div>
            </div>


            <div className='login-form-container'>

                    
                <div className='login-form-card'>
                {loading ? 
                
                <div>
                    <ColouredLoadingSymbol/>
                </div>
                : <>
                    <div style={{display:"flex", justifyContent: "center", alignItems: "center"}}>
                        <img src={Logo} alt="LogoBordered" className="LogoBordered" />
                    </div>
                    <div className="m-2">
                        {used ? 
                        <div className='mt-2'>
                            <STC.Alert variant={used ? 'danger' : 'success'}>
                                {errorMsg}
                            </STC.Alert>
                        </div>
                        :
                        <div className="mt-2 text-center">
                            <div align='start'><strong>Booking ID:</strong> {responseData.bookingId}</div>
                            <div align='start'><strong>School:</strong> {responseData.schoolName}</div>
                            <div align='start'><strong>Currency:</strong> {responseData.currency.code} {responseData.currency.symbol}</div>
                            <EmergencyPaymentForm emergencyData={responseData} date={new Date()} />
                        </div>
                        }
                        
                    </div>
                    </>
                    }
                </div>
                
            </div>
        </div>
    )
}